module.exports = __webpack_public_path__ + "static/media/8f4048b3-bba1-41f1-8c24-1a423065df24.8ca456ab.jpeg";